import { ResourceType } from '../types/resource';
import { Url } from '@wix/da-url';
import { ThemeOptions, ThemeSkin, } from '@wix/da-react-context/pkg/ThemeContext';
export function getUserType(_a) {
    var type = _a.type;
    return type === 'super group' ? 'super' : type;
}
/** Returns true if (gr)user is a group */
export function isGroup(user) {
    return Boolean(user.type.includes('group'));
}
/** Returns group or user type id based on given gruser */
export function getUserTypeId(user) {
    return isGroup(user) ? ResourceType.GROUP : ResourceType.USER;
}
export function getDefaultAvatarSrc(theme, themeSkin) {
    if (theme === ThemeOptions.LIGHT) {
        if (themeSkin === ThemeSkin.GREEN) {
            return Url.staticCDNLink('eclipse/icons/p07-green.svg?1');
        }
        return Url.staticCDNLink('eclipse/icons/p07-light.svg?1');
    }
    return Url.staticCDNLink('eclipse/icons/p07-dark.svg?1');
}
export function getUserAvatarSrc(user) {
    if (!user) {
        return null;
    }
    if (isGroup(user)) {
        return user.usericon;
    }
    if (user.usericonDefault || !user.usericon) {
        return null;
    }
    return user.usericon;
}
//# sourceMappingURL=helpers.js.map